/* Estrani - mobiele menulade in één niveau. Door Claude gebouwd, veilig te
   verwijderen: haal de twee regels ai-menulade.* uit snippets/ai-hoofd.liquid.

   Waarom dit bestaat: het thema stopt het hele winkelmenu achter één item
   ("Shop"). Op een telefoon kostte dat drie tikken om bij een collectie te
   komen, en de lade stond voor driekwart leeg. Dit script leest hetzelfde
   Shopify-menu uit en tekent het opnieuw als één lijst met grijze
   groepskopjes, zoals je het bij de meeste modewinkels ziet.

   Het raakt de opmaak van het thema niet aan: het bouwt een eigen <nav>
   ernaast. De originele navigatie wordt pas verborgen zodra de onze er staat,
   dus faalt dit script, dan valt alles gewoon terug op het thema.
   Alleen onder 750px; de desktop blijft volledig ongemoeid. */
(function () {
  'use strict';

  var SMAL = '(max-width: 749px)';

  function tekst(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function pijl() {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 14 14');
    s.setAttribute('width', '14');
    s.setAttribute('height', '14');
    s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', 'M5 2.5L9.5 7L5 11.5');
    p.setAttribute('fill', 'none');
    p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '1.3');
    p.setAttribute('stroke-linecap', 'round');
    p.setAttribute('stroke-linejoin', 'round');
    s.appendChild(p);
    return s;
  }

  function kopje(naam) {
    var h = document.createElement('p');
    h.className = 'ai-menu__kop';
    h.textContent = naam;
    return h;
  }

  /* Een gewone regel: alleen een link, geen uitklapper. */
  function simpeleRij(a, klasse) {
    var l = document.createElement('a');
    l.className = klasse;
    l.href = a.getAttribute('href');
    l.textContent = tekst(a);
    return l;
  }

  /* Een regel met kinderen. De hele regel klapt open; de categorie zelf is
     het eerste item in de uitklapper ("Alle jassen"). Eerst was de naam een
     link en het pijltje een knop, maar dan staan er twee doelen naast elkaar
     die iets anders doen en tik je per ongeluk door naar een lijst van 33
     producten terwijl je alleen wou kijken wat erin zit. */
  function rijMetSub(a, kinderen, nr) {
    var naam = tekst(a);
    var id = 'ai-menu-sub-' + nr;

    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'ai-menu__rij ai-menu__rij--knop';
    knop.setAttribute('aria-expanded', 'false');
    knop.setAttribute('aria-controls', id);

    var label = document.createElement('span');
    label.className = 'ai-menu__hoofd';
    label.textContent = naam;
    knop.appendChild(label);

    var pijlvak = document.createElement('span');
    pijlvak.className = 'ai-menu__klap';
    pijlvak.appendChild(pijl());
    knop.appendChild(pijlvak);

    var lijst = document.createElement('ul');
    lijst.className = 'ai-menu__sub';
    lijst.id = id;
    lijst.hidden = true;

    /* Bovenaan de uitklapper de weg naar de hele categorie. */
    var alleLi = document.createElement('li');
    var alleLink = document.createElement('a');
    alleLink.className = 'ai-menu__sub-alles';
    alleLink.href = a.getAttribute('href');
    alleLink.textContent = 'Alle ' + naam.toLowerCase();
    alleLi.appendChild(alleLink);
    lijst.appendChild(alleLi);

    kinderen.forEach(function (k) {
      var li = document.createElement('li');
      var kl = document.createElement('a');
      kl.href = k.getAttribute('href');
      kl.textContent = tekst(k);
      li.appendChild(kl);
      lijst.appendChild(li);
    });

    knop.addEventListener('click', function () {
      var open = knop.getAttribute('aria-expanded') === 'true';
      knop.setAttribute('aria-expanded', open ? 'false' : 'true');
      lijst.hidden = open;
      knop.classList.toggle('is-open', !open);
    });

    var blok = document.createDocumentFragment();
    blok.appendChild(knop);
    blok.appendChild(lijst);
    return blok;
  }

  function bouw(lade) {
    if (!window.matchMedia(SMAL).matches) return;
    if (lade.querySelector('.ai-menu')) return;

    var nav = lade.querySelector('.menu-drawer__navigation');
    if (!nav) return;
    var top = nav.querySelector('ul.menu-drawer__menu');
    if (!top) return;

    var eigen = document.createElement('nav');
    eigen.className = 'ai-menu';
    eigen.setAttribute('aria-label', 'Hoofdmenu');

    var boven = document.createElement('div');
    var onder = document.createElement('div');
    var zagGroep = false, teller = 0, iets = false;

    [].forEach.call(top.children, function (li) {
      var det = li.querySelector('details');
      var directeLink = li.querySelector('a');

      /* Geen uitklapper: een losse pagina. Alles vóór de eerste groep komt
         bovenaan te staan, alles erna onderaan bij de servicelinks. */
      if (!det) {
        if (!directeLink) return;
        var doel = zagGroep || !boven ? onder : boven;
        doel.appendChild(simpeleRij(directeLink, zagGroep ? 'ai-menu__dienst' : 'ai-menu__los'));
        iets = true;
        return;
      }

      var kinderlijst = det.querySelector('.menu-drawer__menu--childlist');
      if (!kinderlijst) return;
      zagGroep = true;

      var groep = document.createElement('div');
      groep.className = 'ai-menu__groep';
      var naam = tekst(det.querySelector('summary .menu-drawer__menu-item-text'));
      if (naam) groep.appendChild(kopje(naam));

      [].forEach.call(kinderlijst.children, function (kli) {
        var hoofd = kli.querySelector('a');
        if (!hoofd) return;
        var klein = kli.querySelector('ul.menu-drawer__menu--grandchildlist');
        var kinderen = klein ? [].slice.call(klein.querySelectorAll('a')) : [];
        teller++;
        if (kinderen.length) {
          groep.appendChild(rijMetSub(hoofd, kinderen, teller));
        } else {
          var r = document.createElement('div');
          r.className = 'ai-menu__rij';
          r.appendChild(simpeleRij(hoofd, 'ai-menu__hoofd'));
          groep.appendChild(r);
        }
      });

      /* De groep zelf wijst ook ergens naartoe (Shop -> /collections/all).
         Die link zou anders verdwijnen, dus hij komt onderaan de groep. */
      var eigenLink = det.querySelector('.menu-drawer__title');
      if (eigenLink && eigenLink.getAttribute('href')) {
        var alles = document.createElement('a');
        alles.className = 'ai-menu__alles';
        alles.href = eigenLink.getAttribute('href');
        alles.textContent = 'Alles bekijken';
        groep.appendChild(alles);
      }

      if (boven) { eigen.appendChild(boven); boven = null; }
      eigen.appendChild(groep);
      iets = true;
    });

    if (!iets) return;
    if (boven) eigen.appendChild(boven);
    if (onder.children.length) {
      var service = document.createElement('div');
      service.className = 'ai-menu__groep ai-menu__groep--dienst';
      service.appendChild(kopje('Klantenservice'));
      service.appendChild(onder);
      eigen.appendChild(service);
    }

    nav.parentNode.insertBefore(eigen, nav);
    lade.classList.add('ai-menu-klaar');
  }

  function rond() {
    var laden = document.querySelectorAll('.menu-drawer');
    for (var i = 0; i < laden.length; i++) bouw(laden[i]);
  }

  var wacht = null;
  function plan() {
    if (wacht) return;
    wacht = setTimeout(function () { wacht = null; rond(); }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rond);
  } else {
    rond();
  }
  new MutationObserver(plan).observe(document.documentElement, {
    childList: true, subtree: true
  });
  window.addEventListener('resize', plan);
})();
